import type { RouteLocationRaw } from 'vue-router';
import type { EventListItemDTO } from '~/shared/api/client/events/events.dto';
import { CLIENT_EVENTS_URL } from '~/shared/api/client/events/events.const';
import { EVENTS_GALLERY_DETAIL_ROUTE_NAMES } from '~/shared/lib/events-routes.const';

export function isPastEvent(
  event: Pick<EventListItemDTO, 'end_time'>,
): boolean {
  return new Date(event.end_time) < new Date();
}

/**
 * A past event with a photo gallery links to it,
 * everything else — to the event detail page.
 */
export function getEventRoute(event: EventListItemDTO): RouteLocationRaw {
  if (isPastEvent(event)) {
    const photoGallery = event.photo_gallery?.[0];
    if (photoGallery) {
      return {
        name: EVENTS_GALLERY_DETAIL_ROUTE_NAMES.photos,
        params: { id: photoGallery.id },
      };
    }
  }

  return `${CLIENT_EVENTS_URL}${event.id}`;
}
